const { getElement } = window.BAO.Utils

let dropdownLoaded = false

class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.siteDrawers = getElement('site-drawers')

    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch(
        this.dataset.sectionId,
        `${window.Shopify.routes.root}?view=dropdown`,
      )
      .then((res) => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(
          res[this.dataset.sectionId],
        )
        const myself = newDOM.querySelector(this.localName)

        this.outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    this.addEventListener('click', this.handleToggleButtonClick.bind(this))

    this.onPointerMove = this.onPointerMove.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onClickBurger = this.onClickBurger.bind(this)

    this.addEventListener('pointermove', this.onPointerMove)
    this.addEventListener('mouseleave', this.onMouseLeave)
    this.listeners.add(this.els.burger.element, 'click', this.onClickBurger)

    this.addEventListener('focusin', this.handleFocusIn.bind(this))

    this.addEventListener('keyup', this.handleEscapePress.bind(this))
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    const menuToggleEl = event.target.closest(
      '[data-header-dropdown-el="menu-dropdown-toggle"]',
    )

    if (!menuToggleEl) {
      return
    }

    const parentItemEl = menuToggleEl.closest(
      '[data-header-dropdown-el="item"]',
    )
    if (!parentItemEl) return
    const menuDropdownEl = getElement(
      '[data-header-dropdown-el="menu-dropdown"]',
      {
        context: parentItemEl,
      },
    )

    if (!menuDropdownEl) return

    const isExpanded = menuToggleEl.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      menuToggleEl.setAttribute('aria-expanded', 'false')
      menuDropdownEl.setAttribute('aria-hidden', 'true')
      this.siteDrawers.close('header')
    } else {
      menuToggleEl.setAttribute('aria-expanded', 'true')
      menuDropdownEl.setAttribute('aria-hidden', 'false')
      window.BAO.Utils.revealDeferredImages(menuDropdownEl)
      this.siteDrawers.open('header')
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-hidden="false"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    const menuDropdownToggleEls = document.querySelectorAll(
      '[data-header-dropdown-el="menu-dropdown-toggle"]',
    )
    const menuDropdownEls = document.querySelectorAll(
      '[data-header-dropdown-el="menu-dropdown"]',
    )
    const burgerButton = this.querySelector(
      '[data-header-dropdown-el="burger"]',
    )

    if (menuDropdownToggleEls) {
      menuDropdownToggleEls.forEach((menuToggleEl) => {
        menuToggleEl.setAttribute('aria-expanded', 'false')
      })
    }

    if (menuDropdownEls) {
      menuDropdownEls.forEach((menuDropdownEl) => {
        menuDropdownEl.setAttribute('aria-hidden', 'true')
      })
    }

    if (burgerButton) {
      burgerButton.classList.remove('hd-Banner_Link-open')
    }

    this.siteDrawers.close('header')
  }

  onPointerMove (event) {
    if (this.querySelector('.hd-Banner_Link-open')) {
      return
    }

    const activeTrigger = event.target.closest(
      '[data-header-dropdown-el="trigger"]',
    )

    const burgerButton = this.querySelector(
      '[data-header-dropdown-el="burger"]',
    )
    if (burgerButton) {
      burgerButton.classList.remove('hd-Banner_Link-open')
    }

    if (!activeTrigger) {
      this.closeDropdowns()

      return
    }

    const matchedDropdown = this.querySelector(
      `[data-header-dropdown-el="menu-dropdown"]#${activeTrigger.dataset.id}`,
    )

    if (matchedDropdown) {
      this.querySelectorAll(
        '[data-header-dropdown-el="menu-dropdown"]',
      ).forEach((menuDropdownEl) => {
        menuDropdownEl.setAttribute(
          'aria-hidden',
          menuDropdownEl !== matchedDropdown,
        )
      })

      window.BAO.Utils.revealDeferredImages(matchedDropdown)

      this.querySelectorAll(
        '[data-header-dropdown-el="menu-dropdown-toggle"]',
      ).forEach((menuToggleEl) => {
        menuToggleEl.setAttribute(
          'aria-expanded',
          menuToggleEl.dataset.id === matchedDropdown.id,
        )
      })

      if (window.drawers?.activeDrawerKey === 'header') {
        this.siteDrawers.close('header')
      }

      this.siteDrawers.open('header')
    } else {
      this.closeDropdowns()
    }
  }

  onClickBurger (event) {
    const burger = event.target.closest('[data-header-dropdown-el="burger"]')
    if (!burger) return

    const matchedDropdown = this.querySelector(
      `[data-header-dropdown-el="menu-dropdown"]#burger`,
    )

    const isOpen = burger.classList.contains('hd-Banner_Link-open')

    this.closeDropdowns()

    if (!isOpen) {
      burger.classList.add('hd-Banner_Link-open')
      matchedDropdown.setAttribute('aria-hidden', 'false')
      window.BAO.Utils.revealDeferredImages(matchedDropdown)
      this.siteDrawers.open('header')
    }
  }

  onMouseLeave () {
    const burger = this.querySelector(
      `[data-header-dropdown-el="menu-dropdown"]#burger`,
    )

    if (burger.hasAttribute('aria-hidden', 'true')) {
      this.closeDropdowns()
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
